// window.onload = function() {
//     console.log("here");
// };

const createScrollToggle = (selector, offset = 200) => {
  const element = document.querySelector(selector);

  if (!element) {
    return;
  }

  let ticking = false;

  const update = () => {
    const { top } = element.getBoundingClientRect();
    const windowHeight = window.innerHeight;

    if (top < windowHeight - offset) {
      element.classList.add('expanded');
    } else {
      element.classList.remove('expanded');
    }

    ticking = false;
  };

  const onScroll = () => {
    if (!ticking) {
      window.requestAnimationFrame(update);
      ticking = true;
    }
  };

  window.addEventListener('scroll', onScroll, { passive: true });
  update();
};

createScrollToggle('.section-spacing .container');
createScrollToggle('.shopify-section--newsletter .newsletter');
